import React from "react";
import { Route, Switch } from "react-router-dom";
import Loadable from 'react-loadable';

import CircularProgress from "components/CircularProgress";
import Error404 from "../../components/ErrorPages/Error404";

const Dashboard = Loadable({
  loader: () => import('../../containers/GuildLibrarian/Dashboard'),
  loading: CircularProgress,
});
const PublicMacros = Loadable({
  loader: () => import('../../containers/GuildLibrarian/PublicMacros'),
  loading: CircularProgress,
});
const PublicDiagramTemplates = Loadable({
  loader: () => import('../../containers/GuildLibrarian/PublicDiagramTemplates'),
  loading: CircularProgress,
});

const GuildLibrarian = ({ match }) => (
  <Switch>
    <Route exact path={`${match.url}/dashboard`} component={Dashboard} />
    <Route exact path={`${match.url}/public-macros`} component={PublicMacros} />
    <Route exact path={`${match.url}/public-diagram-templates`} component={PublicDiagramTemplates} />
    <Route component={() => <Error404 redirectTo="/guildlibrarian/public-macros" />} />
  </Switch>
);

export default GuildLibrarian;
